<h2 mat-dialog-title>Confirmation Message</h2>
<mat-dialog-content class="mat-typography">

<p>{{data.message}}</p>
<!-- <div>
  <div class="content-container">
    <span class="content-span full-width">{{data.message}}</span>
  </div>
  <mat-dialog-actions align="end">
      <button mat-flat-button id="no-button"  class="btn btn-default waves-effect" [mat-dialog-close]="false">NO</button>
      <button mat-flat-button id="yes-button" class="btn btn-success waves-effect waves-light" [mat-dialog-close]="true">YES</button>
  </mat-dialog-actions>

</div> -->

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button id="no-button" 
      (click)="closeDialog()"
     class="btn btn-default waves-effect" [mat-dialog-close]="false">NO</button>
    <button mat-flat-button id="yes-button" class="btn btn-success waves-effect waves-light" [mat-dialog-close]="true">YES</button>
</mat-dialog-actions>
